import React from 'react'

import PropTypes from 'prop-types'

import BonusCreditsBar from './Components/BonusCreditsBar'
import SaleOffBar from './Components/SaleOffBar'
import SubscribeBar from './Components/SubscribeBar'

function TopNotificationBars({ discountConfig = {
  barColor: 'green',
  body: '',
  creditsAdded: 0,
  endingDate: 0,
  useTimer: false,
  noticeBarDiscount: 0,
}, bonusCreditsActive = false, saleCampaignActive = false, subscriptionTopbarActive = false }) {
  if (subscriptionTopbarActive) {
    return <SubscribeBar />
  }

  if (bonusCreditsActive) {
    return (
      <BonusCreditsBar
        barColor={discountConfig.barColor}
        content={discountConfig.body}
        creditsAdded={discountConfig.creditsAdded}
        endingDate={discountConfig.endingDate}
        useTimer={discountConfig.useTimer}
      />
    )
  }

  if (saleCampaignActive) {
    return (
      <SaleOffBar
        barColor={discountConfig.barColor}
        content={discountConfig.body}
        discountPhrase={discountConfig.discountPhrase}
        discount={discountConfig.noticeBarDiscount}
        endingDate={discountConfig.endingDate}
        useTimer={discountConfig.useTimer}
      />
    )
  }

  return null
}

TopNotificationBars.propTypes = {
  discountConfig: PropTypes.shape({
    barColor: PropTypes.string,
    body: PropTypes.string,
    creditsAdded: PropTypes.number,
    endingDate: PropTypes.number,
    useTimer: PropTypes.bool,
    noticeBarDiscount: PropTypes.number,
    discountPhrase: PropTypes.string,
  }),
  bonusCreditsActive: PropTypes.bool,
  saleCampaignActive: PropTypes.bool,
  subscriptionTopbarActive: PropTypes.bool,
}

export default TopNotificationBars
